/**
 * Contact Form Detail Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.contactFormDetailFormatter = function(value, row) {
    let html = '';
    if (row.message) {
        html += row.message;
    }
    return html;
};
